(() => {
  if (customElements.get('pavera-rozlucky-inquiry')) return;
  class PaveraRozluckyInquiry extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      document.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target instanceof Element ? event.target.closest('a[data-prv-inquiry]') : null;
        if (!link || link.getAttribute('href') !== '#' + this.id) return;
        const field = this.querySelector('[data-prf-variant]');
        const picnic = this.querySelector('[data-prf-picnic]');
        if (!field || !picnic) return;
        event.preventDefault();
        if (link.dataset.prvAddon === 'true') {
          picnic.checked = true;
          picnic.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          const option = Array.from(field.options).find((item) => item.value === link.dataset.prvVariant);
          if (option) {
            field.value = option.value;
            field.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        const heading = this.querySelector('[data-prf-heading]');
        if (heading) heading.focus({ preventScroll: true });
        this.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        if (window.location.hash !== '#' + this.id) {
          try { window.history.replaceState(null, '', '#' + this.id); } catch (_) {}
        }
      }, { signal });
      const status = this.querySelector('[data-prf-status]');
      if (status) status.focus();
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  }
  customElements.define('pavera-rozlucky-inquiry', PaveraRozluckyInquiry);
})();